import { render, staticRenderFns } from "./BarMealAction.vue?vue&type=template&id=3ff72777&scoped=true"
import script from "./BarMealAction.vue?vue&type=script&lang=js"
export * from "./BarMealAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff72777",
  null
  
)

export default component.exports